import { render } from "./ChangeDocument.vue?vue&type=template&id=339b00af&scoped=true"
import script from "./ChangeDocument.vue?vue&type=script&lang=js"
export * from "./ChangeDocument.vue?vue&type=script&lang=js"

import "./ChangeDocument.vue?vue&type=style&index=0&id=339b00af&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-339b00af"]])

export default __exports__